NewPartnerRegister

<template>
    <div>
        <b-modal
            no-close-on-backdrop
            title="Cadastrar Parceiro"
            header-bg-variant="orange"
            header-text-variant="light"
            centered
            size="lg"
            hide-footer
            v-model="open"
        >
            <b-row>
                <b-col cols="12" :md="!hasCnpj ? '6' : '12'" :lg="!hasCnpj ? '4': '12'" class="mb-2">
                    <label>CNPJ:</label> <br>
                    <input 
                        type="text" 
                        class="form-control" 
                        v-mask="'##.###.###/####-##'" 
                        placeholder="11.111.111/0001-11"
                        v-model="dataPartner.cnpj"
                        @change="consultCnpj()"
                    >
                </b-col>

                <b-col cols="12" v-if="isText">
                    <h4 class="text-center mt-4">Este CNPJ já existe, deseja vincular parceiro?</h4>
                </b-col>

                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Nome fantasia:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Nome fantasia"
                        v-model="dataPartner.nome_fantasia"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>E-mail:</label> <br>
                    <input
                        type="email"
                        class="form-control"
                        placeholder="exemplo@gmail.com"
                        v-model="dataPartner.email"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Nome Responsável:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Nome Responsável"
                        v-model="dataPartner.nome"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>RG:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        v-mask="'##.###.###-#'"
                        placeholder="11.111.111-1"
                        v-model="dataPartner.rg"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>CPF:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        v-mask="'###.###.###-##'"
                        placeholder="111.111.111-11"
                        v-model="dataPartner.cpf"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>CEP:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        v-mask="'#####-###'"
                        placeholder="11111-111"
                        v-model="dataPartner.endereco.cep"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Rua:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Rua exemplo"
                        v-model="dataPartner.endereco.rua"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Número:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="N°"
                        v-model="dataPartner.endereco.numero"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Bairro:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Digite o bairro do parceiro"
                        v-model="dataPartner.endereco.bairro"
                
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Complemento:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Casa/apto"
                        v-model="dataPartner.endereco.complemento"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Cidade:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        name="cidade_id"
                        placeholder="Cidade do parceiro"
                        v-model="localidade"
                        disabled
                        autocomplete="nope"
                        :key="dataPartner.endereco.cidade_id"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Estado:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Selecione o estado do parceiro"
                        v-model="dataPartner.endereco.estado_id"
                        disabled
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Celular:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        v-mask="'(##)#####-####'"
                        placeholder="(11)11111-1111"
                        v-model="dataPartner.contato.celular"
                    >
                </b-col>
                <b-col cols="12" md="6" lg="4" class="mb-2" v-if="!hasCnpj">
                    <label>Telefone:</label> <br>
                    <input
                        type="text"
                        class="form-control"
                        v-mask="'(##)####-####'"
                        placeholder="(11)1111-1111"
                        v-model="dataPartner.contato.telefone"
                    >
                </b-col>
                <div class="card" v-if="!hasCnpj">
                    <h4 class="text-center mt-4 p-2">Dados bancário para recebimento</h4>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <b-form-group label="Selecione o Banco">
                                    <b-form-select v-model="dataPartner.dataBank.bank" :options="BankTypes"></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-3">
                                <label>Número da agência:</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="AG"
                                    v-model="dataPartner.dataBank.bank_ag"
                                >
                            </div>
                            <div class="col-md-3">
                                <label>Número da conta:</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="dataPartner.dataBank.bank_cc"
                                    placeholder="CC"
                                >
                            </div>
                            <div class="col-md-3">
                                <label>Tipo da conta</label>
                                <select required v-model="dataPartner.dataBank.account_type" class="form-control mb-3">
                                    <option value="Corrente">Corrente</option>
                                    <option value="Poupança">Poupança</option>
                                </select>
                            </div>
                            <div class="col-md-3 ">
                                <label for="price_range">Valor máximo da venda</label>
                                <select required v-model="dataPartner.dataBank.price_range" class="form-control mb-3">
                                    <option value="100">Até R$ 100,00</option>
                                    <option value="500"> Entre R$ 100,00 e R$ 500,00</option>
                                    <option value="600">Mais de R$ 500,00</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label for="business_type">Descrição do seu negócio</label>
                                <textarea
                                    v-model="dataPartner.dataBank.business_type"
                                    class="form-control mb-3"
                                    placeholder="Descrição do negócio"
                                    cols="50"
                                    ></textarea>
                            </div>
                        </div>
                    </div>
                </div>

            </b-row>
            <div class="d-flex justify-content-around mt-4">
                <b-button
                    variant="outline-danger"
                    style="width: 48%;"
                    @click="open = false"
                >
                    Cancelar
                </b-button>

                    <b-button
                        v-if="!isText && hasCnpj"
                        variant="success"
                        style="width: 48%;"
                        @click="consultCnpj()"
                    >Pesquisar</b-button>

                <b-button
                    v-else
                    variant="success"
                    style="width: 48%;"
                    @click="addNewPartner()"
                >
                    Vincular parceiro
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BankTypes from '@/enums/BankTypes';
import makeToast from '@/mixins/makeToast';

export default {
    emits: ['updateTable'],
    mixins: [makeToast],
    data() {
        return {
            open: false,
            hasCnpj: true,
            loading: false,
            isText: false,
            localidade: "",
            BankTypes,
            dataPartner: {
                nome: "",
                nome_fantasia: "",
                email: "",
                rg: "",
                cpf: "",
                cnpj: "",
                endereco: {
                    cep: "",
                    rua: "",
                    bairro: "",
                    numero: "",
                    complemento: "",
                    cidade_id: "",
                    estado_id: ""
                },
                contato: {
                    celular: "",
                    telefone: ""
                },
                dataBank: {
                    bank: "",
                    bank_ag: "",
                    bank_cc: "",
                    account_type: "",
                    price_range: "",
                    business_type: ""
                }
            },
            cepConsult: {
                consulted: false,
                isValidAddress: true,
                isValidNeighborhood: true,
            },
        }
    },

    computed: {
        ...mapState({
            dadosUsuario: (state) => state.dadosUsuario,
        }),
        ...mapGetters('general', ['getCities']),
    },

    watch: {
    'dataPartner.endereco.cep': function () {
      this.consultCep();
    },
  },

    methods: {
        ...mapActions('shopkeeper', ['createNewPartner', 'validarCnpj']),

        toggleOpen() {
            this.open = !this.open;
            this.cleanUpModal();
        },

        addNewPartner() {
            this.$store.dispatch('startLoader');
            this.loading = true;

            this.dataPartner['shopkeeper_id'] = this.dadosUsuario.id;
            this.dataPartner['tipo_usuario_id'] = 3;

            this.createNewPartner(this.dataPartner)
                .then(() => {
                    this.toggleOpen();
                    this.$emit('updateTable');
                    this.cleanUpModal();
                })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                    this.loading = false;
                });
        },

        consultCnpj() {
            if(this.dataPartner.cnpj.length <18) {
              this.makeToast(
                'Erro',
                'Número do cnpj está incorreto',
                'danger'
              );
              return
            }
          
            this.loading = true;
            this.$store.dispatch('startLoader');

            this.$store
            .dispatch('user/validarCnpj', this.dataPartner.cnpj.replace(/[^0-9]/g, ''))
            .then((resp) => {
                this.hasCnpj = resp.data.valid;
                this.isText = this.hasCnpj ? true : false;
            })
            .finally(() => {
                this.$store.dispatch('endLoader');
                this.loading = false;
            });
        },

        consultCep() {
            if (!this.loading && this.dataPartner.endereco.cep.length === 9) {
                this.loading = true;
                this.$store.dispatch('startLoader');

                this.$store
                    .dispatch('user/consultCep', this.dataPartner.endereco.cep)
                    .then(async (res) => {
                        this.validateCepResults(res.data);
                })
                .catch((error) => {
                  this.makeToast('Oopss!', error.response.data.message, 'danger');
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.dispatch('endLoader');
                });
            }

              if (this.dataPartner.endereco.cep.length === 0) {
                this.cepConsult.consulted = false;
                this.dataPartner.endereco.rua = null;
                this.dataPartner.endereco.bairro = null;
                this.dataPartner.endereco.cidade_id = null;
                this.dataPartner.endereco.estado_id = null;
              }
        },

        validateCepResults(result) {
            this.cepConsult.consulted = true;
            this.cepConsult.isValidAddress = !!result.logradouro;
            this.cepConsult.isValidNeighborhood = !!result.bairro;
            this.dataPartner.endereco.rua = result.logradouro || null;
            this.dataPartner.endereco.bairro = result.bairro || null;
            this.dataPartner.endereco.cidade_id = result.cidade_id || null;
            this.localidade = result.localidade || null;
            this.dataPartner.endereco.estado_id = result.uf || null;

            this.ErrorMessages.address = null;
            this.ErrorMessages.neighborhood = null;
            this.ErrorMessages.city_id = null;
            this.ErrorMessages.estado_id = null;
        },

        cleanUpModal() {
            this.dataPartner.nome = null;
            this.dataPartner.nome_fantasia = null;
            this.dataPartner.email = null;
            this.dataPartner.rg = null;
            this.dataPartner.cpf = null;
            this.dataPartner.cnpj = null;
            this.dataPartner.endereco.cep = null;
            this.dataPartner.endereco.rua = null;
            this.dataPartner.endereco.bairro = null;
            this.dataPartner.endereco.numero = null;
            this.dataPartner.endereco.complemento = null;
            this.dataPartner.endereco.cidade_id = null;
            this.dataPartner.endereco.estado_id = null;
            this.dataPartner.contato.celular = null;
            this.dataPartner.contato.telefone = null;
            this.dataPartner.dataBank.bank = null;
            this.dataPartner.dataBank.bank_ag = null;
            this.dataPartner.dataBank.bank_cc = null;
            this.dataPartner.dataBank.account_type = null;
            this.dataPartner.dataBank.price_range = null;
            this.dataPartner.dataBank.business_type = null;
            this.isText = false;
            this.hasCnpj = true;
        },
    }
}
</script>